/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Standard DataComponent pagination.
 * @author Tom Verschoore de la Houssaije

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-pagination-custom-size[_ngcontent-%COMP%]   .page-link[_ngcontent-%COMP%]{padding:.25rem .5rem;font-size:.875rem}.sym-pagination-custom-size[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]{cursor:default}.sym-pagination-custom-size[_ngcontent-%COMP%]   .page-link[_ngcontent-%COMP%]{line-height:1.5;min-width:35px;text-align:center;text-decoration:none;padding-left:0;padding-right:0}"];
export { styles as styles };
